module.exports = __webpack_public_path__ + "f27e9aa9a2c4fe498f87d0babd91c6f0.jpg";